//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { cloneDeep, isUndefined, isEqual, isEmpty, map, isNumber, isNull, find } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { consignationActionsCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals/Modals'
import { LabelText, InputLogin, TextModal, DatePickerFilterLabel } from '../../theme/GlobalCss'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseDatePicker from '../../hooks/UseDatePicker'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import Calendar from '../../assets/icones/global/calendar.svg'

import { uriList } from '../../routings/settings/RouteList'

//////STYLED//////
const ConsignationrWrapper = styled.div`
	position: relative;
`
const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapperCustom = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: flex-end;
	font-size: 13px;
`
const InputLabelWrapper = styled.div`
	max-width: 100%;
	display: flex;
	justify-content: space-around;
	margin-bottom: 35px;
	margin-top: ${(props) => props.modalTitle === 'contract' && props.theme.margin.mt};
`
const InputWrapper = styled.div`
	max-width: auto;
	max-height: auto;
	display: flex;
	flex-direction: column;
`
const InputLoginCustom = styled(InputLogin)`
	width: 150px;
	border: 1px solid ${(props) => props.theme.colors.cancel};
	margin-right: 15px;
	margin-top: 5px;
`
const ErrorInputMsg = styled.div`
	width: max-content;
	color: ${(props) => props.theme.colors.error};
`
//////STYLED//////

const Consignation = () => {
	let history = useHistory()
	const [row, setRow] = useState({})
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' })

	// FILTER
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// MODALS
	const [showModal, setShowModal] = useState(false)
	const [modalTitle, setmodalTitle] = useState('')
	const [stateDefaultValues, setStateDefaultValues] = useState()
	const [mailError, setMailError] = useState(false)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const { register, handleSubmit, setValue, errors, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})
	const {
		translations,
		consignation,
		consignationFilter,
		user,
		userKioskPerimeter,
		userRolePrivileges,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
		isFromRedirect,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			consignation: state.consignation,
			consignationFilter: state.consignation.header,
			kioskPerimeter: state.user.identity.kioskSelected,
			salesHistoryManager: state.salesHistoryManager.transaction,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			contractSend: state.consignation.contractSend,
			userRolePrivileges: state.user.identity.rolePrivileges,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
			isFromRedirect: state.table.isFromRedirect,
		}),
		shallowEqual
	)

	const actionsConsignation = bindActionCreators(consignationActionsCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// DATE PICKER
	const [
		dateConsignationShowModal,
		dateConsignationOpenDateModalHandler,
		dateConsignationRenderModal,
		dateConsignationStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').subtract(15, 'days').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	// Columns
	const [columns, setColumns] = useState([])
	/////////////////////////////// HANDLER //////////////////////////////////////

	// SEARCH BAR
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmitFilter = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)
		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsConsignation.postConsignation(handleFilterSend(), pg)
	}

	// MODAL

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
		setmodalTitle('infos')
		setUpdate(true)
		if (update) {
			setUpdate(false)
		}
	}

	const handleModalContract = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
		setmodalTitle('contract')
		setUpdate(true)
		if (update) {
			setUpdate(false)
		}
	}

	const updateGuestInfosHandler = (data) => {
		const kioskId = map(user.identity.kioskSelected, 'id')
		actionsConsignation.updateCustomerInfos(data, row, kioskId)
		handleModal()
	}

	const sendConsignementContractHandler = () => {
		const idContract = row.saleOrderLineId
		actionsConsignation.sendConsignementContract(idContract)
		handleModal()
		setUpdate(false)
		setMailError(false)
		isUndefined(row.clientEmail) || (isEmpty(row.clientEmail) && handleModalError())
	}

	const handlePagingRecap = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'saleOrder.date',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsConsignation.postConsignation(handleFilterSend(), pg)
	}

	const handleModalError = () => {
		setMailError(true)
	}

	const handleViewContract = (row) => {
		const idContract = row.saleOrderLineId
		actionsConsignation.viewConsignementContract(idContract)
	}
	// in case of row dont have id to set inside search field we redirect like a getAll
	const handleSeeSale = (row) => {
		if (row.transactionPo !== '') {
			actionsConsignation.getTransactionNumber(row)
			history.push(`${uriList.sales}${uriList.salesHistory}`)
		} else {
			history.push(`${uriList.sales}${uriList.salesHistory}`)
		}
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}

		filtersOut = { ...searchFieldUpdated, ...filtersIn }

		return {
			...filtersOut,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
			datesRange: {
				dateStart: dateConsignationStateDate.date.startDate,
				dateEnd: dateConsignationStateDate.date.endDate,
			},
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'consignmentContract_distributor',
				dataHook: 'distributor',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_distributor'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.distributor.company.labelToDisplay',
			},
			{
				columnReferential: 'consignmentContract_kioskCode',
				dataHook: 'codeKiosk',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'consignmentContract_kioskName',
				dataHook: 'labelKiosk',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_kioskLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.description',
			},
			{
				columnReferential: 'consignmentContract_clientKioskCode',
				dataHook: 'codeKioskCustomer',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_kioskCustomerCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.labelToOwner',
			},
			{
				columnReferential: 'consignmentContract_article',
				dataHook: 'labelItem',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_itemLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemKiosk.itemDistributor.item.labelToDisplay',
			},
			{
				columnReferential: 'consignmentContract_transactionDate',
				dataHook: 'transactionDate',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_transactionDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.transactionDate).utc().format('DD/MM/YYYY HH:mm'),
				sortableId: 'saleOrder.date',
			},
			{
				columnReferential: 'consignmentContract_name',
				dataHook: 'clientLastName',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_userLastName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.customerLastname',
			},
			{
				columnReferential: 'consignmentContract_firstName',
				dataHook: 'clientFirstName',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_userFirstName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.customerFirstname',
			},
			{
				columnReferential: 'consignmentContract_email',
				dataHook: 'clientEmail',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_userEmail'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.customerEmail',
			},
			{
				columnReferential: 'consignmentContract_contractNumber',
				dataHook: 'contractPo',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_contractPo'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.transactionId',
			},
			{
				columnReferential: 'consignmentContract_transactionNumber',
				dataHook: 'transactionPo',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_transactionPo'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.transactionId',
			},
			{
				columnReferential: 'consignmentContract_consignmentPriceHT',
				dataHook: 'consignmentPrices.consignPriceHT',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_priceConsignHt'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNumber(props.row.consignmentPrices.consignPriceHT)
						? `${props.row.consignmentPrices.consignPriceHT}${props.row.currency.symbol}`
						: `0${props.row.currency.symbol}`,
				sortableId: 'priceDepositTotalTTC',
			},
			{
				columnReferential: 'consignmentContract_VAT',
				dataHook: 'consignmentPrices.consignRateTVA',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_priceTva'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNumber(props.row.consignmentPrices.consignRateTVA) ? `${props.row.consignmentPrices.consignRateTVA}%` : '0%',
				sortableId: 'saleOrder.id',
			},
			{
				columnReferential: 'consignmentContract_consignmentPriceTTC',
				dataHook: 'consignmentPrices.consignPriceTTC',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_priceConsignTtc'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNumber(props.row.consignmentPrices.consignPriceTTC)
						? `${props.row.consignmentPrices.consignPriceTTC}${props.row.currency.symbol}`
						: `0${props.row.currency.symbol}`,
				sortableId: 'priceDepositTotalTTC',
			},
			{
				columnReferential: 'consignmentContract_emailSend',
				dataHook: 'mailState.translationKey',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_mailState'],
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				isAuthorize: true,
				sortableId: 'lastEmailDate',
			},
			{
				columnReferential: 'consignmentContract_emailSendDate',
				dataHook: 'mailSendingDate',
				headerName: translations['page__transactionsHistory__admin__consignmentContract_tableHeader_mailDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.mailSendingDate) ? moment(props.row.mailSendingDate).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'lastEmailDate',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'consignation',
					paperActionsList: [
						{
							name: translations['tooltip__admin__consignmentContract__tableAction__customerInfo_update'],
							translationKey: 'tooltip__admin__consignmentContract__tableAction__customerInfo_update',
							clickAction: (row) => {
								handleModal(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[6])),
							//iconDef: edit,
						},
						{
							name: translations['page__transactionsHistory__admin__consignmentContract_tableAction_consignSee'],
							translationKey: 'tooltip__admin__global__action__consignmentContract_detail',
							clickAction: (row) => {
								handleViewContract(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[11])) &&
								row.canViewConsignmentContract,
							//iconDef: view,
						},
						{
							name: translations['page__transactionsHistory__admin__consignmentContract_tableAction_consignSend'],
							clickAction: (row) => {
								handleModalContract(row)
							},
							isVisible: (row) =>
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[6])) &&
								row.canManageConsignmentContract,
						},
						{
							name: translations['page__transactionsHistory__admin__consignmentContract_tableAction_saleSee'],
							translationKey: 'tooltip__admin__itemReferential__tableAction__itemDetail',
							clickAction: (row) => {
								handleSeeSale(row)
							},
							isVisible: (row) =>
								!isUndefined(
									find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[7])
								) /* && !isEqual(row.transactionPo, '') */, // voir le priv renvoyé
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 10,
		labelPageTable: 'consignmentContract',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				defaultValue: searchValue,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		},
		paging: {
			fnSendTo: (paging) => handlePagingRecap(paging),
		},
	})
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		const filtersCp = cloneDeep(consignationFilter)
		filtersCp.withFilters = true

		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [consignationFilter])

	useEffect(() => {
		if (dateConsignationStateDate.showModal) {
			actionsConsignation.postConsignation(handleFilterSend(), paging)
		}
	}, [dateConsignationShowModal])

	const [update, setUpdate] = useState(false)

	useEffect(() => {
		if (user) {
			setValue('lastNameCt', row.clientLastName)
			setValue('firstNameCt', row.clientFirstName)
			setValue('mailCt', row.clientEmail)
			setValue('lastName', row.clientLastName)
			setValue('firstName', row.clientFirstName)
			setValue('mail', row.clientEmail)
			setStateDefaultValues(getValues)
		}
	}, [update])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === consignation.transactionNumber.idTransaction) return
		handleSubmitFilter()
	}, [filters.searchField])

	// SUBMIT FILTER

	useEffect(() => {
		if (consignation.isUpdated) {
			actionsConsignation.postConsignation(handleFilterSend(), paging)
		}
	}, [consignation.isUpdated])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)

		if (!isEmpty(consignation) && !isUndefined(consignation)) {
			cfg.paging = {
				totalElements: consignation.paging.totalElements,
				totalPages: consignation.paging.totalPages,
				fnSendTo: (paging) => handlePagingRecap(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [consignation.items])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__transactionsHistory__admin__consignmentContract_title']
		cfg.paging = {
			totalElements: consignation.paging.totalElements,
			totalPages: consignation.paging.totalPages,
			fnSendTo: (paging) => handlePagingRecap(paging),
		}
		cfg.actions = {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				defaultValue: searchValue,
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		}
		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__transactionsHistory__admin__consignmentContract_tableFilter_transactionDate'] + ' :'}
					</label>
					<DatePickerTransactionIcon onClick={dateConsignationOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateConsignationStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateConsignationStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		if (filters.filtersSelection) {
			cfg.actions.rest = [
				() => (
					<DropdownCheckbox
						/*MAIL SEND  */
						title={translations['page__transactionsHistory__admin__consignmentContract_tableFilter_mailState']}
						data={filters.filtersSelection.mailState.filterElements}
						translations={translations}
						toTranslate
						selectActionsHandler={handleCheckElements}
						paperTopPosition={'40'}
						dropColor={'blueColor'}
						submitOnClose={handleSubmitFilter}
						target={'mailState'}
					/>
				),
				() => (
					<DropdownCheckbox
						/*ARTICLE*/
						title={translations['page__transactionsHistory__admin__consignmentContract_tableFilter_itemLabel']}
						data={filters.filtersSelection.itemLabels.filterElements}
						selectActionsHandler={handleCheckElements}
						translations={translations}
						paperTopPosition={'40'}
						dropColor={'blueColor'}
						submitOnClose={handleSubmitFilter}
						target={'itemLabels'}
					/>
				),
				() => (
					<DropdownCheckbox
						/*DISTRIBUTOR*/
						title={translations['common__text__fastFilter_distributor']}
						data={filters.filtersSelection.distributor.filterElements}
						selectActionsHandler={handleCheckElements}
						translations={translations}
						paperTopPosition={'40'}
						dropColor={'blueColor'}
						submitOnClose={handleSubmitFilter}
						target={'distributor'}
					/>
				),
			]
		}

		setConfigTableTitle(cfg)
	}, [translations, filters, dateConsignationStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)

		cfgCp.export = {
			privilege: userPrivileges.export[8],
			url: urlExport[2],
			bd: {
				filtersSelection: filters.filtersSelection,
				datesRange: { dateEnd: dateConsignationStateDate.date.endDate, dateStart: dateConsignationStateDate.date.startDate },
				searchField: searchValue,
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}
		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}
		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		// If we came from redirection
		if (!isEmpty(consignation.transactionNumber)) {
			setSearchValue(consignation.transactionNumber.idTransaction)
			let filtersCP = cloneDeep(filters)
			filtersCP.searchField = consignation.transactionNumber.idTransaction
			setFilters(filtersCP)
		}
	}, [consignation.transactionNumber])

	useEffect(() => {
		return function cleanUp() {
			actionsConsignation.resetConsignation()

			actionsTable.resetPaggingConfig()
		}
	}, [])

	const [swytch, setSwytch] = useState(false)

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			let state_date = {}
			// If we got data from store, we set dates here
			if (!isEmpty(consignation.transactionNumber)) {
				// For request
				state_date.startDate = moment(consignation.transactionNumber.dateCreated).subtract(3, 'hours')
				state_date.endDate = moment(consignation.transactionNumber.dateCreated).add(3, 'hours')

				// And for state of datepicker
				setStartDate(moment(state_date.startDate).toDate())
				setEndDate(moment(state_date.endDate).toDate())
			} else {
				// Or default case
				state_date.startDate = moment().startOf('day').subtract(15, 'days').toDate()
				state_date.endDate = moment().hours(23).minutes(59).toDate()
			}
			const filtersCp = {
				withFilters: searchValue?.length > 0 && !isFromRedirect ? true : false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchField: consignation.transactionNumber?.idTransaction || '',
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				searchFieldUpdated: false,
			}

			actionsConsignation.postConsignation(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [swytch, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsConsignation.postConsignation(
				{
					withFilters: false,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
					datesRange: {
						dateStart: moment().startOf('day').subtract(15, 'days').toDate(),
						dateEnd: moment().hours(23).minutes(59).toDate(),
					},
				},
				paging
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
		setStartDate(moment().startOf('day').subtract(15, 'days').toDate())
		setEndDate(moment().hours(23).minutes(59).toDate())
	}, [userKioskPerimeter])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={consignation.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={consignation.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsConsignation.postConsignation}
			/>
		)
	}, [consignation, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateConsignationRenderModal()}

			<Modals
				closeModalHandler={handleModal}
				showModal={showModal}
				minWidth="500px"
				color="black"
				icon={true}
				title={
					modalTitle === 'infos'
						? `${translations['page__transactionsHistory__admin__consignmentContract__modalInformation_title']} :`
						: `${translations['page__transactionsHistory__admin__consignmentContract__modalMail_title']} :`
				}
			>
				{' '}
				{modalTitle === 'contract' && translations['page__transactionsHistory__admin__consignmentContract__modalMail_body']}
				<form onSubmit={modalTitle === 'infos' ? handleSubmit(updateGuestInfosHandler) : handleSubmit(sendConsignementContractHandler)}>
					<InputLabelWrapper modalTitle="contract">
						<InputWrapper>
							<LabelText>
								{translations['page__transactionsHistory__admin__consignmentContract__modalCommon__field_lastName']}* :
							</LabelText>
							{modalTitle === 'infos' && (
								<InputLoginCustom
									name="lastName"
									type="text"
									placeholder={
										translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_lastName']
									}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
									})}
								/>
							)}
							{errors?.lastName && <ErrorInputMsg>{errors.lastName.message}</ErrorInputMsg>}
							{modalTitle === 'contract' && (
								<InputLoginCustom
									name="lastNameCt"
									type="text"
									placeholder={
										translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_lastName']
									}
									disabled
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
									})}
								/>
							)}
							{errors?.lastNameCt && <ErrorInputMsg>{errors.lastNameCt.message}</ErrorInputMsg>}
						</InputWrapper>

						<InputWrapper>
							<LabelText>
								{translations['page__transactionsHistory__admin__consignmentContract__modalCommon__field_firstName']}* :
							</LabelText>
							{modalTitle === 'infos' && (
								<InputLoginCustom
									name="firstName"
									type="text"
									placeholder={
										translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_firstName']
									}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
									})}
								/>
							)}
							{errors?.firstName && <ErrorInputMsg>{errors.firstName.message}</ErrorInputMsg>}
							{modalTitle === 'contract' && (
								<InputLoginCustom
									name="firstNameCt"
									type="text"
									placeholder={
										translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_firstName']
									}
									disabled
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
									})}
								/>
							)}
							{errors?.firstNameCt && <ErrorInputMsg>{errors.firstNameCt.message}</ErrorInputMsg>}
						</InputWrapper>
						<InputWrapper>
							<LabelText>
								{translations['page__transactionsHistory__admin__consignmentContract__modalCommon__field_email']}* :
							</LabelText>
							{modalTitle === 'infos' && (
								<InputLoginCustom
									name="mail"
									type="email"
									placeholder={
										translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_email']
									}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										pattern: {
											value: RegExp(
												/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
											),
											message: translations['common__text__invalidEmail'],
										},
									})}
								/>
							)}

							{errors?.mail && <ErrorInputMsg>{errors.mail.message}</ErrorInputMsg>}
							{modalTitle === 'contract' && (
								<InputLoginCustom
									name="mailCt"
									type="email"
									placeholder={
										translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_email']
									}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										pattern: {
											value: RegExp(
												/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
											),
											message: translations['common__text__invalidEmail'],
										},
									})}
									disabled
								/>
							)}
							{errors?.mailCt && <ErrorInputMsg>{errors.mailCt.message}</ErrorInputMsg>}
						</InputWrapper>
					</InputLabelWrapper>
					<ButtonWrapperCustom>
						<Button
							actionHandler={handleModal}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						{modalTitle === 'infos' && (
							<Button type="submit" text={translations['common__text__save']} bgColor={Theme.colors.validation} img={Validation} />
						)}
						{modalTitle === 'contract' && (
							<Button type="submit" text={translations['common__text__send']} bgColor={Theme.colors.validation} img={Validation} />
						)}
					</ButtonWrapperCustom>
				</form>
			</Modals>
			<ConsignationrWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</ConsignationrWrapper>

			{mailError && (
				<Modals>
					<TextModal>{translations['page__transactionsHistory__admin__consignmentContract_emptyField']}</TextModal>
					<ButtonWrapperCustom>
						<Button actionHandler={handleModal} text={translations['common__text__ok']} bgColor={Theme.colors.error} margin="true" />
					</ButtonWrapperCustom>
				</Modals>
			)}
		</Fragment>
	)
}

Consignation.propTypes = {}

Consignation.defaultPropTypes = {}

export default Consignation
